import React from 'react';

import TextField from '../../../forms/TextField';

export default function ThirdPartyTagIds() {
  return (
    <TextField
      name="thirdPartyTagIds"
      label="Third Party Tag IDS (Comma Separated)"
      // Return null for empty string
      normalizeOutput={({ target: { value } }) => value || null}
    />
  );
}
